import React, { useEffect, useState } from 'react';
import RenderComponent from './render-component';
import { Box, Typography, Input, TextField, Divider } from '@material-ui/core';
import { Button, SaveButton, TextInput } from 'react-admin';

const EditFooterRotationLogoText = (props: any) => {
  const [state, setState] = useState('');
  const [letterSpacing, setLetterSpacing] = useState(0.6);
  const [fontSize, setFontSize] = useState(14);

  useEffect(() => {
    if (props.widget) {
      setState(props.widget.data.text);
      setLetterSpacing(props.widget.data.letterSpacing);
      setFontSize(props.widget.data.fontSize);
    }
  }, [props.widget]);

  return (
    <div>
      <Box display={'flex'} alignItems={'center'}>
        <Box
          display={'flex'}
          flexDirection={'column'}
          marginRight={'30px'}
          width={'40%'}
          justifyContent={'space-around'}
          height={'200px'}
        >
          <TextField
            label='Logo Text'
            variant='outlined'
            value={state}
            onChange={(event) => {
              setState(event.target.value);
            }}
          />
          <Divider />
          <TextField
            label='Font Size'
            variant='outlined'
            inputProps={{ step: '0.1', type: 'number' }}
            value={fontSize}
            onChange={(event) => {
              setFontSize(Number(event.target.value));
            }}
          />
          <Divider />
          <TextField
            label='Letter Spacing'
            variant='outlined'
            inputProps={{ step: '0.01', type: 'number' }}
            value={letterSpacing}
            onChange={(event) => {
              setLetterSpacing(Number(event.target.value));
            }}
          />
        </Box>
        <Box width={'60%'}>
          <RenderComponent
            widgetType={'footer-logo-rotation-text'}
            widgetData={{ text: state, letterSpacing, fontSize }}
          />
        </Box>
      </Box>
      <Box marginBottom={'30px'}>
        <Button
          onClick={(data) => {
            props.onSubmit({
              text: state,
              letterSpacing: letterSpacing,
              fontSize: fontSize,
            });
          }}
          className='cancel-button'
          label='Save'
        />
        <Button
          onClick={props.onCancel}
          className='cancel-button'
          label='Cancel'
        />
      </Box>
    </div>
  );
};

export default EditFooterRotationLogoText;
